import { AclStrategy } from "@/shared/api/groups"

export const NULL_GROUP_OPTION_VALUE = '__NULL__'

export const ACL_STRATEGY_OPTIONS: { value: AclStrategy; label: string }[] = [
    { value: AclStrategy.INHERIT_ONLY, label: 'Только наследование' },
    { value: AclStrategy.INHERIT_PLUS_OVERRIDES, label: 'Наследование + переопределение' },
    { value: AclStrategy.OVERRIDES_ONLY, label: 'Только переопределение' },
]

export const getAclStrategyLabel = (
    strategy: AclStrategy,
    options: { value: AclStrategy; label: string }[] = ACL_STRATEGY_OPTIONS
): string => {
    const option = options.find((opt) => opt.value === strategy)
    return option ? option.label : strategy
}
